import { Component, OnInit, ViewChild, ChangeDetectorRef, Compiler, ViewEncapsulation  } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { RoutesService } from '../../services/routes.service';
import { CommonService } from '../../services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../../services/alert.service';
import { RouteService } from '../../services/route.service';
import { UsersService } from '../../services/users.services';
import swal from 'sweetalert2';
import { isUndefined } from "util";

import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { ExcelService } from '../../services/excel.service';
import { NgxSpinnerService } from 'ngx-spinner';


declare var $: any;

export interface RouteElement {
  Divipol_code: string;
}


@Component({
  selector: 'app-routes',
  templateUrl: './routes.component.html',
  styleUrls: ['./routes.component.css', ],
  encapsulation : ViewEncapsulation.None
})
export class RoutesComponent implements OnInit {
  
  
  routesByC: MatTableDataSource<RouteElement>;
  routeId: any;
  idRfid: any;
  routeIdSave: any;
  rfids: any = [];
  routeDescription: any;
  messageResponse: any;
  type: any;
  title: any;
  swRfid: any = 0;
  dataTable: any;
  // dataParam: any[] = [];
  // publicDeals: Deal[] = [];
  displayedColumns: string[];
  filterMenuVisible: boolean = false;

  dispatchers: any = [];
  selectedRouteDispatchers = [];
  dispatchersSettings = {};

  routeCodes = [];
  selectedRouteCodes = [];
  routeCodesSettings = {};

  routeNames = [];
  selectedRouteNames = [];
  routeNamesSettings = {};

  routeStatus = [
      { Id: 1, Description : "Activa"}, 
      {Id: 0, Description : "Inactiva"}
    ];
  selectedRouteStatus = [];
  routeStatusSettings = {};

  routeRFIDs = [];
  selectedRouteRFIDs = [];
  routeRFIDsSettings = {};

  reportData: any = []
  newRoute: any = {};
  isAddingNewRout : boolean = false;
  isNewRfidRemote : boolean = false;

  @ViewChild('modalAddUpdateRfid') modalAddUpdateRfid: HTMLElement;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private routesService: RoutesService,
    private routeService: RouteService,
    private commonService: CommonService,
    public activeModal: NgbActiveModal,
    private alertService: AlertService,
    private usersService: UsersService,
    private chRef: ChangeDetectorRef,
    private modalService: NgbModal,
    private compiler:Compiler,
    private excelService: ExcelService,
    private spinner: NgxSpinnerService,
    ) {

  }

  ngOnInit() {
    this.setSpinnersSettings();
    this.getAllRfids();

    this.getRoutes();
    this.getUsers();
  }

  getAllRfids(){
    this.routesService.getAllRfids().then(response => {
      console.log(response)
      this.routeRFIDs = response
      this.routeCodes.sort(function (a, b) {
        if (a.code_rfid > b.code_rfid) {
          return 1;
        }
        if (a.code_rfid < b.code_rfid) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
    });
  }

  setSpinnersSettings() {
    this.routeCodesSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: 'Description',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };

    this.routeNamesSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: 'Description',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };

    this.routeStatusSettings = {
      singleSelection: true,
      idField: 'Id',
      textField: 'Description',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };

    this.routeRFIDsSettings = {
      singleSelection: false,
      idField: 'code_rfid',
      textField: 'code_rfid',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };

    this.dispatchersSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };
  }

  toggleFilterMenu() {
    this.filterMenuVisible = !this.filterMenuVisible;
  }

  applyFilter(filterValue: string) {
    this.routesByC.filter = filterValue.trim().toLowerCase();

    if (this.routesByC.paginator) {
      this.routesByC.paginator.firstPage();
    }
  }

  setTable(data){
    this.displayedColumns = ["Name", 'Divipol_code', 'Description', 'Time', "Id", "Edit", 'Status'];
    this.routesByC = new MatTableDataSource(data);
    this.routesByC.paginator = this.paginator;
    this.routesByC.paginator._intl.itemsPerPageLabel = "Filas por Página:"
    this.routesByC.sort = this.sort;
    // Esconde el paginador porque no es posible cambair la paginación por problemas con el componente
    $(".mat-paginator-page-size").css("display", "none")
  }
  sortData(e){
    console.log(e)
  }

  getRoutes(): void {
    this.routesService.getRoutes(this.commonService.getUserName()).then(response => {
      console.log(response)
       this.routeCodes = []
       this.routeNames = []
      for (var i in response) {
        this.setReportData(response[i])
        this.routeCodes.push({Id : response[i].Divipol_code, Description : response[i].Divipol_code})
        this.routeNames.push({Id : response[i].Name, Description : response[i].Name})
        // this.routeRFIDs.push({Id : response[i].Name, Description : response[i].Name})
      }

      this.routeCodes.sort(function (a, b) {
        if (a.Description > b.Description) {
          return 1;
        }
        if (a.Description < b.Description) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
      this.routeNames.sort(function (a, b) {
        if (a.Description > b.Description) {
          return 1;
        }
        if (a.Description < b.Description) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });

      this.setTable(response);
      console.log(this.routeCodes)
    });
  }

  filterRoutes(): void {
    this.spinner.show();
    var codes = this.selectedRouteCodes.map(({ Id }) => "'" + Id + "'").toString();
    var names = this.selectedRouteNames.map(({ Id }) => "'" + Id + "'").toString();
    var status = this.selectedRouteStatus.map(({ Id }) => Id).toString();
    var rfids = this.selectedRouteRFIDs.map(({ code_rfid }) => "'" + code_rfid + "'").toString();
    var dispatchers = this.selectedRouteDispatchers.map(({ name }) => "'" + name + "'").toString();

    this.routesService
                .getDrivers_withFilters(this.commonService.getUserName(), 
                                          codes, names, status, rfids, dispatchers)
      .then(response => {
        this.setTable(response)
        this.reportData = []
        for (var i in response) {
          this.setReportData(response[i])
        }
        this.spinner.hide();
      });
  }

  setReportData(routeObject) {
    this.reportData.push({
      Codigo: routeObject.Divipol_code,
      Nombre: routeObject.Name,
      Ruta: routeObject.Description,
      Tiempo: routeObject.Time,
    })
  }

  // saveRoutes(): void {
  //   const that = this
  //   const nRows = $('#rowsRoutes tr').length;
  //   const user = this.commonService.getUserName()
  //   const arrayValues = new Array()
  //   const dataParam = new Array()
  //   const dataTable = new Array()
  //   $('.descriptionRoute').each(function () {
  //     const text = $.trim($(this).text());
  //     const values = new Object();
  //     const dat = $(this).text()
  //     dataTable.push(dat);
  //     if (dataTable[1] !== '') {
  //       arrayValues.push(values);
  //       console.log('values : ', values);
  //     }
  //   });
  //   console.log('dataTable[1]  :', dataTable[1]);
  //   console.log('dataTable[0]  :', dataTable[0]);
  //   // for (let i = arrayValues.length - 1; i >= 0; i--) {
  //   console.log('dataTable[1] : ', dataTable[1])

  //   if (dataTable[1] !== '' && dataTable[1] !== 'undefined') {
  //     console.log('por el if : ')
  //     this.routesService.saveRoutesService(dataTable[1], dataTable[0], user)
  //       .then(obj => {
  //         const response = JSON.parse(obj.toString());
  //         console.log('resp : ', response)
  //         if (response) {
  //           if (response.status === 'EXITO') {
  //             console.log(response.result)
  //             this.title = response.message;
  //             this.type = 'success';
  //             swal({
  //               title: this.title,
  //               text: '',
  //               type: this.type,
  //               showCancelButton: false,
  //               confirmButtonColor: '#3085d6',
  //               cancelButtonColor: '#ff5370',
  //               confirmButtonText: 'Volver',
  //               // cancelButtonText: 'No'
  //             });
  //             // window.location.href = '/home/routes';
  //             // this.router.navigate(['/home/routes']);

  //             var N = this.routesByC.data.length;
  //             // console.log(N);
  //             // this.routesByC.splice(N-1, 1);
  //             $('.tbl').empty();
  //             this.getRoutes();
  //             $('#routeRow').css('display', 'inline');
  //             // this.router.navigateByUrl('/red-pill;x=white-rabbit/neo');
  //             /* that.router.navigateByUrl('/home/routes').then(nav => {
  //                console.log(nav); // true if navigation is successful
  //              }, err => {
  //                console.log(err); // when there's an error
  //              });*/

  //           } else {
  //             this.title = response.message;
  //             this.type = 'error';
  //             swal({
  //               title: this.title,
  //               text: '',
  //               type: this.type,
  //               showCancelButton: false,
  //               confirmButtonColor: '#3085d6',
  //               cancelButtonColor: '#ff5370',
  //               confirmButtonText: 'Volver',
  //               // cancelButtonText: 'No'
  //             });
  //           }
  //         }
  //       });
  //   } else {
  //     this.title = 'Ingresa la información.';
  //     this.type = 'error';
  //     swal({
  //       title: this.title,
  //       text: '',
  //       type: this.type,
  //       showCancelButton: false,
  //       confirmButtonColor: '#3085d6',
  //       cancelButtonColor: '#ff5370',
  //       confirmButtonText: 'Volver',
  //       // cancelButtonText: 'No'
  //     });
  //   }
  // }

  saveRfidsNew() {
    let that = this;
    var cont = 1;
    var nRows = $('#rowsRfid tr').length;
    var title = "";
    let dataParam = new Array()
    const user = this.commonService.getUserName();
    const arrayValues = new Array()
    var id, rfidCode, type, Id_dispatcher;
    var params;
    let sw = 0;
    var result = 0;
    var list = $('.rfidTd');
    console.log('length : ', list.length)

    var lengthList = list.length
    var countlist = 0
    $('.rfidTd').each(function () {
      const values = new Object();
      const text = $.trim($(this).text());
      var isremoteCheck = $(this).find("input")
      

      countlist = countlist + 1;
      var msj = 0;
      if (countlist === lengthList) { msj = 1 }
      if (cont === 1) {
        id = text;
      } else if (cont === 2) {
        rfidCode = text;
      } else if (cont === 3) {
        if (text === 'Inicio ruta') {
          type = true;
        } else {
          type = false;
        }
      }
      else if (cont === 4) {
        // debugger;
        const valuea = ($(this).children('div:first'));
        Id_dispatcher = valuea.text();
      }
      console.log('id ::::::::::::::::::::::::::::::::::::::::::::::::::::: ', id)
      console.log('cont : :  : :', cont)
      console.log('text : :  : :', text)
      if (cont % 3 === 0) {
        if (id !== '') {
          params = {
            'Id': parseInt(id),
            'RfidCode': String(rfidCode),
            'Type': type,
            'IdRoute': that.routeIdSave,
            'Id_dispatcher': Id_dispatcher
          };
        } else {
          console.log('ingreso a else ')
          params = {
            'RfidCode': String(rfidCode),
            'Type': type,
            'IdRoute': that.routeIdSave,
            'Id_dispatcher': Id_dispatcher
          };
        }
        dataParam.push(params);
        console.log('vamos a guardar')

        params.Id_dispatcher = $("#newRfidDispatcher").val()
        params.IsRemote = $("#newRfidCheckboxRemote")[0].checked == true ? "true" : "false"
        params.Type = $("#newRfidStartOrEnd")[0].checked == true ? true : false

        if(params.RfidCode == ""){
          swal({
            title: 'Debe ingresar un código. ',
            text: '',
            type: 'error',
            showCancelButton: false,
            // cancelButtonText: 'No'
          });
          return false
        }

        if(params.IsRemote == "true" && params.RfidCode.length != 6){
          swal({
            title: 'El Rfid remoto debe ser de 6 dígitos. ',
            text: '',
            type: 'error',
            showCancelButton: false,
            // cancelButtonText: 'No'
          });
          return false
        }



        console.log(params)

        that.routesService.saveRfids(params)
          .then(obj => {
            console.log("msj ", msj)
            const response = JSON.parse(obj.toString());
            console.log('response : ', response)
            var result = response.result
            console.log('response : ', result);
            if (response) {
              if (response.status === 'EXITO') {
                cont = 1;
                if (sw === 0 && msj === 1) {
                  that.rfids = []
                  that.getrfids();
                  $('#tblAdd').remove();
                  $('#divAdd').css('display', 'inline');
                  $('#divSave').css('display', 'none');
                  swal({
                    title: 'Codigo adicionado exitosamente',
                    text: '',
                    type: 'success',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#ff5370',
                    confirmButtonText: 'Volver',
                    // cancelButtonText: 'No'
                  });
                }
              } else {
                this.swRfid = 1;
                sw = 1;
                if (sw === 1 && msj === 1) {
                  swal({
                    title: 'El código ingresado ya existe. ',
                    text: '',
                    type: 'success',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#ff5370',
                    confirmButtonText: 'Volver',
                    // cancelButtonText: 'No'
                  });
                }
              }
            }
          });
        cont = 1;
      } else {
        cont++;
      }
    });
    that.router.navigate(['/home/routes']);
  }

  getrfids(): void {
    this.routeService.getRfids(this.routeIdSave).then(response => {
      // debugger;
      this.rfids = response;
      this.rfids.forEach(element => {
        if (element.id_dispatcher == 0) { element.id_dispatcher = null }
      });
    });
  }

  addText(){
    alert("sicas")
  }

  addRow() {
    $('#divAdd').css('display', 'none');
    $('#divSave').css('display', 'inline');
    $('#rowsRfid').each(function () {
      // console.log($(".button").text())
    });
    var nRows = $("#rowsRfid tr").length;
    var rowsCount = nRows + 1
    console.log('rowsCount : ', rowsCount)
    // $('#rfidRow').css('display', 'none');
    var idCheck = 'checkboxStatus-' + rowsCount
    var classCheck = 'check-' + rowsCount
    $('#rowsRfid').append('<tr class="tbl" id="tblAdd">' +
      '<td class="rfidTd tbl" style="visibility: hidden"></td>' +
      '<td id=\"newcodeId\" class="rfidTd tbl" contenteditable=\'true\' style=\"border:solid 1px;\">' +
      '</td>' +

      '<td class="rfidTd tbl">' +
      '<div class="checkbox-fade fade-in-primary">' +
      '<label class="ui-switch switch-icon switch-solid-info switch-large">' +
      '<input class="border-checkbox" type="checkbox" id="newRfidStartOrEnd" name="checkboxStatus">' +
      '<span class="cr">' +
      '</i>' +
      '</span>' +

      '<label   id=\"newRfidStartOrEnd_label">Fin Ruta</label>' +
      '</div>' +
      '</td>' +

      '<td>' +
        '<div class="checkbox-fade fade-in-primary">' + 
        '<label class="ui-switch switch-icon switch-solid-info switch-large">' +
            '<input rfidType=\"normal\" class="border-checkbox" type="checkbox" id="newRfidCheckboxRemote" name="checkboxRemote"'+
              '#status="ngModel" [(ngModel)]="isNewRfidRemote"'+
              '>' +
            '<span class="cr">' +
            '</span>' +
          '</label>' +
          '<label  id=\"newRfidRemote\" class="border-checkbox-label" for="checkboxRemote">' +
            'Normal' +
          '</label>' +
      '</div>' +
      '</td>' +
      '<td>' +
      '<select class="custom form-control" name="dispatcherId" id="newRfidDispatcher" ' +
              'style="min-width: 200px;"' +
              '>' +
            '<select> '+
      '</td>' +
      '<td></td>' +
      '</tr>');

    console.log($("#newcodeId"))
    $("#newcodeId").focus()

    $("#newRfidCheckboxRemote").click(function(){
      console.log(this.checked)
      console.log($("#newRfidRemote"))
      if(this.checked){
        $("#newRfidRemote").html("Remoto")
      }else{
        $("#newRfidRemote").html("Normal")
      }
    })

    $("#newRfidStartOrEnd").click(function(){
      console.log(this.checked)
      console.log($("#newRfidStartOrEnd"))
      if(this.checked){
        $("#newRfidStartOrEnd_label").html("Inicio Ruta")
      }else{
        $("#newRfidStartOrEnd_label").html("Fin Ruta")
      }
    })

    for(var i in this.dispatchers){
      $("#newRfidDispatcher").append('<option value="' + this.dispatchers[i].id +'" >' + this.dispatchers[i].name + '</option>')
    }
    
    event.preventDefault();
  }

  getUsers(): void {
    this.usersService.getUsers(this.commonService.getUserName())
      .then(response => {
        // debugger;
        this.dispatchers = response;
        console.log(response)
        this.dispatchers.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      });
  }

  toDetails(routeId){
    this.router.navigate(['/home/route/'+ routeId]);
  }
  
  async openModalRfid(routeId: any) {
    let that = this;
    this.routeIdSave = routeId;
    const modalRfid = this.modalService.open(this.modalAddUpdateRfid, { size: 'lg' });
    this.routeId = Object.assign({}, routeId);
    this.getrfids();
    $(".modal-content").css("width", "110%")
    $(".modal-content").css("overflow", "visible")

    await this.delay(300);
    console.log($("ngb-modal-window"))
    $("ngb-modal-window").css("overflow", "scroll")
    console.log($("ngb-modal-window").css("overflow"))

  }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

  saveRfid(idRfid: any): void {
    console.log('idRfid : :  : :', idRfid)
    console.log('idRfid 2: :  : :', JSON.stringify(idRfid))

    var type
    // if(idRfid.id_dispatcher == 0){idRfid.id_dispatcher = 'NULL'}
    console.log('idRfid.id_dispatcher : : : ', idRfid.id_dispatcher)
    var params = {
      'Id': parseInt(idRfid.id),
      'RfidCode': String(idRfid.code_rfid),
      'Type': idRfid.type,
      'IdRoute': idRfid.id_route,
      'Id_dispatcher': idRfid.id_dispatcher,
      'IsRemote' : idRfid.is_remote == true? "true":"false",
    };
    console.log(idRfid.is_remote)
    if(idRfid.is_remote){
      if(idRfid.code_rfid.length != 6){
        swal({
          title: 'El código RFID debe tener 6 caracteres',
          text: '',
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#ff5370',
          confirmButtonText: 'Volver',
          // cancelButtonText: 'No'
        });
        return ;
      }
    }

    this.routesService.saveRfids(params).then(obj => {
      const response = JSON.parse(obj.toString());
      console.log('response json : ', response)
      if (response) {
        swal({
          title: 'Tu RFID fue actualizado con exito!',
          text: '',
          type: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#ff5370',
          confirmButtonText: 'Volver',
          // cancelButtonText: 'No'
        });
        // that.messageResponse = response.message;
        // console.log('messageResponse : ', that.messageResponse);
        this.getrfids();
      }
    });
  }

  deleteRfid(idRfid: any): void {
    const that = this;
    swal({
      title: '¿Esta seguro de borrar el código seleccionado?',
      text: '',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#ff5370',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    }).then(function (s) {
      console.log(s);
      if (s.dismiss !== undefined) {
        if (s.dismiss.toString() === 'cancel') {
        }
      } else {
        if (s.value !== undefined) {
          if (s.value) {
            // alert(id);
            that.routesService.deleteRfid(idRfid).then(obj => {
              const response = JSON.parse(obj.toString());
              console.log('response json : ', response)
              if (response) {
                // that.messageResponse = response.message;
                // console.log('messageResponse : ', that.messageResponse);
                that.getrfids();
              }
            });
          }
        }
      }
    }).catch(swal.noop);
  }

  refreshRouters() {
    let that = this;
    console.log("redirect ")
    that.router.navigate(['/home/routes']);
  }

  exportToExcel() {

    if (this.reportData.length > 0) {
      this.excelService.exportAsExcelFile(this.reportData, 'Lista de Rutas');
    } else {
      swal({
        title: 'No hay datos para exportar',
        text: '',
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#ff5370',
        confirmButtonText: 'Volver',
        // cancelButtonText: 'No'
      }).catch(swal.noop);
    }
  }

  addNewRoute(){
    console.log(this.newRoute)
    const user = this.commonService.getUserName()
    const arrayValues = new Array()
    const dataTable = new Array()
      this.routesService.saveRoutesService(this.newRoute.Name,
                                            this.newRoute.Description, 
                                            this.newRoute.Divipol_code, 
                                            this.newRoute.Travel_time, 
                                            this.newRoute.Distance, 
                                            this.newRoute.Forward_or_back, 
                                            user
                                            )
        .then(obj => {
          const response = JSON.parse(obj.toString());
          console.log(response)
          if (response) {
            if (response.status === 'EXITO') {
              console.log(response.result)
              this.title = response.message;
              this.type = 'success';
              swal({
                title: this.title,
                text: '',
                type: this.type,
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#ff5370',
                confirmButtonText: 'Volver',
                // cancelButtonText: 'No'
              });
              this.filterRoutes();
              this.isAddingNewRout = false;
            } else {
              this.title = response.message;
              this.type = 'error';
              swal({
                title: this.title,
                text: '',
                type: this.type,
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#ff5370',
                confirmButtonText: 'Volver',
                // cancelButtonText: 'No'
              });
            }
          }
        });
  }
}





// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/routes/routes.component.ts